module.exports = __webpack_public_path__ + "static/img/bg-pt.9283cc66.webp";